export default [
    {
        name: 'cadastro-empresa',
        path: 'empresa',
        redirect: 'empresa/index',
        component: () => import(/* webpackChunkName: 'cadastro-empresa' */ '@/views/cadastro/empresa/Index'),
        children: [
            {
                meta: {title: 'Lista de empresas'},
                name: 'cadastro-empresa-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'cadastro-empresa' */ '@/views/cadastro/empresa/List.vue'),
            },
        ],
    },
]